// class CustomPopup extends HTMLElement {
//   connectedCallback() {
//     // Move popup to body only if not already in body
//     if (this.parentNode !== document.body) {
//       document.body.appendChild(this);
//     }

//     // Close popup when clicking close button or outside content
//     this.addEventListener('click', e => {
//       if (e.target.closest('.popup-close') || e.target === this) {
//         this.close();
//       }
//     });

//     // Attach click events to all buttons targeting this popup
//     const popupId = `#${this.id}`;
//     document.querySelectorAll(`.popup-trigger[data-popup="${popupId}"]`).forEach(btn => {
//       btn.addEventListener('click', () => {
//         this.open();
//       });
//     });
//   }

//   open() {
//     this.style.display = 'flex';
//     document.body.style.overflow = 'hidden'; // lock scroll
//   }

//   close() {
//     this.style.display = 'none';
//     document.body.style.overflow = ''; // unlock scroll
//   }
// }

// customElements.define('custom-popup', CustomPopup);




class CustomPopup extends HTMLElement {
  connectedCallback() {
    if (this.parentNode !== document.body) document.body.appendChild(this);

    // Close popup when clicking close button or outside content
    this.addEventListener('click', e => {
      if (e.target.closest('.popup-close') || e.target === this) this.close();
    });

    // Delegated event listener for triggers
    document.addEventListener('click', e => {
      const trigger = e.target.closest(`.popup-trigger[data-popup="#${this.id}"]`);
      if (trigger) this.open();
    });
  }

  open() {
    this.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.style.display = 'none';
    document.body.style.overflow = '';
  }
}

customElements.define('custom-popup', CustomPopup);
